import Vue from 'vue'
import Vuex from 'vuex'
import { bookmarkModule } from './Store/BookmarkModule'
import { tagModule } from './Store/TagModule'
import { mapModule } from './Store/MapModule'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    bookmarkModule,
    tagModule,
    mapModule
  }
})
